import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import { generateFaqUrl } from '../utils/generate-faq-url';
import template from './faq-items.component.html';
var FaqItemsComponent = (function () {
    function FaqItemsComponent() {
    }
    FaqItemsComponent.prototype.getFaqItemUrl = function (faqItem) {
        return generateFaqUrl(this.group, faqItem.id);
    };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], FaqItemsComponent.prototype, "faqItems", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FaqItemsComponent.prototype, "group", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], FaqItemsComponent.prototype, "limitTo", void 0);
    FaqItemsComponent = __decorate([
        Component({
            selector: 'faqItems',
            template: template,
        })
    ], FaqItemsComponent);
    return FaqItemsComponent;
}());
export { FaqItemsComponent };
